import NavigationBasicTabs from './NavigationBasicTabs';
var navigationVariantComponentMap = {
  BasicTabs: NavigationBasicTabs
};
export { navigationVariantComponentMap };